/**
 * SafetyCheck
 * The SafetyCheck API
 *
 * The version of the OpenAPI document: master-35d84d79-917289
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface OpenedDto { 
    /**
     * The channel used when opening a AreYouOk.
     */
    channel: OpenedDtoChannel;
    /**
     * Time the person opened the SafetyCheck for the first time.
     */
    openedAt?: string;
}
export enum OpenedDtoChannel {
    Push = 'push',
    Sms = 'sms',
    Email = 'email',
    Voice = 'voice'
};



